@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

$round-bottom: 0 0 4px 4px;
$availability-padding: 8px;
$doctor-spacing: 4px;

.VEHdoctor {
  @include breakpoints.desktop {
    width:240px !important;
    max-width: 240px !important;
    min-width: 240px !important;
  }
}

.doctor {
  width: 100%;
  font-size: 100%; // Reset <button> styles
  border: none; // Reset <button> styles
  margin: 8px $doctor-spacing 0;
  padding: 16px 4px 4px;
  cursor: pointer;
  position: relative;
  display: table;
  scroll-snap-align: start;
  align-items: center;
  text-align: center;
  
  
  @include breakpoints.desktop {
    max-width: 224px;
    min-width: 212px;
  }
}

.docImg {
  float: left;
}

.docImgVEHNameChange {
  float: left;
  box-shadow: none !important;
}

.doctorInfo {
  float: left;
  margin: 0px 10px;
  width:80%;
  font-family: typography.$font-mont;

  .name {
    text-transform: uppercase;
    margin: 0px;
    font-family: typography.$font-mont;
    font-weight: 500;
    font-style: normal;
    font-size: 16px;
    line-height: 21px;
    letter-spacing: 0px;
    vertical-align: middle;
  }
  .availabilityInfo {
    font-weight: 400;
    font-size: 14px;
    color: var(--datepicker-gray); // var(--black);
    font-family: typography.$font-mont;
    font-weight: 400;
    font-style: normal;
    line-height: 19.6px;
    letter-spacing: 0px;
    vertical-align: middle;
    a{
      margin-left: 5px;
      color: var(--blue-02);
    }
  }
}

.indicator {
  position: absolute;
  top: -8px;
  left: 0;
  right: 0;
  height: 4px;
  width: 100%;
  border-radius: $round-bottom;
  background-color: var(--gray-03);
  z-index: var(--float);
}

.avatar {
  display: inline-block;
  border-radius: 50%;
  box-shadow: 0 0 0 2px var(--gray-02); // Outer Ring
  border: 2px solid var(--transparent); // Inner Ring
}

.availability {
  @include typography.caption;
  border-radius: $round-bottom;
  padding: 8px;
  text-align: center;
  color: var(--blue-01);
  white-space: normal;
}

.name {
  margin: 12px 12px 4px;
  white-space: nowrap;
  font-weight: var(--semibold-weight);
  color: var(--black);
  text-wrap: balance;
}

.profile {
  text-align: center;
}

.profileMobile {
  padding: 5px;
  width: 100%;
  display: block;
  overflow: auto;
}

.selected {
  background-color: var(--blue-03-at-30);

  .indicator {
    background-color: var(--blue-01);
  }

  .avatar {
    box-shadow: 0 0 0 2px var(--blue-01); // Outer ring
    filter: none;
  }

  .availability {
    background-color: var(--blue-01);
    color: var(--white);
  }

  a {
    color: var(--white);
  }
}

.doctor:not(:last-child)::after {
  content: "";
  position: absolute;
  top: $availability-padding;
  bottom: $availability-padding;
  right: -1 * ($doctor-spacing + 0.5px); // 0.5px compensates for width of line itself.
  width: 1px;
  background-color: var(--gray-03);
}

.doctor:first-child .indicator {
  border-radius: $round-bottom;
}

.doctor:last-child .indicator {
  border-radius: $round-bottom;
}

.doctor:not(.selected):hover {
  background-color: var(--blue-03-at-30);

  .avatar {
    box-shadow: 0 0 0 2px var(--blue-01-at-30); // Outer ring
    filter: grayscale(30%) opacity(80%);
  }
}

.teleopt {
  @include typography.caption;
}
